import { render, staticRenderFns } from "./jsaOnePageDetail.vue?vue&type=template&id=308de93a"
import script from "./jsaOnePageDetail.vue?vue&type=script&lang=js"
export * from "./jsaOnePageDetail.vue?vue&type=script&lang=js"
import style0 from "./jsaOnePageDetail.vue?vue&type=style&index=0&id=308de93a&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('308de93a')) {
      api.createRecord('308de93a', component.options)
    } else {
      api.reload('308de93a', component.options)
    }
    module.hot.accept("./jsaOnePageDetail.vue?vue&type=template&id=308de93a", function () {
      api.rerender('308de93a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/jsa/jsaOnePageDetail.vue"
export default component.exports